import { STATUS_IDLE } from 'constants/statuses.constants';

export const getInitialState = () => ({
  warnings: [],
  status: STATUS_IDLE,
  error: null,
});
